module.exports = __webpack_public_path__ + "media/images/icons/outlined/wifi-a820ac3c27db82f0bad0694f0734bdc7.svg";